import { render, staticRenderFns } from "./OwnerLogin.vue?vue&type=template&id=c63d0454"
import script from "./OwnerLogin.vue?vue&type=script&lang=js"
export * from "./OwnerLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports